import { get, post, postFileDownload } from "../../../services/request";

export const getRoles = () => get('Common/GetRolesForDropdown');
export const getStatus = () => get('Common/GetStatusForDropdown');
export const getDocumentModules = () => get('Common/GetDocumentModuleForDropdown');
export const getDocumentTypesByModuleId = (moduleId) => get(`Common/GetDocumentTypeForDropdown?moduleId=${moduleId}`);
export const getDocumentTypesWithConfiguration = () => get('Common/GetDocumentTypesWithConfiguration');
export const getStorageTypes = () => get('Common/GetStorageTypeForDropdown');
export const getCommunicationTypes = () => get('Common/GetCommunicationForDropdown');
export const getPriorityTypes = () => get('Common/GetPriorityForDropdown');
export const getRecipientGroup = () => get('Common/GetRecipientGroupForDropdown');
export const getUsers = () => get('Common/GetUsersForDropdown');
export const getInvestors = () => get('Common/GetInvestorForDropdown');
export const getEquityTypeClassByEquityTypeId= data => get(`Common/GetEquityTypeClassByEquityTypeId?equityTypeID=${data}`);
export const getStatusByTypeForDropdown = (type) => get(`Common/GetStatusByTypeForDropdown?type=${type}`);
export const documentDownload = data => postFileDownload('Document/DocumentDownload', data);
export const getHoldCoUsers = () => get('Common/GetHoldCoForDropdown');
export const getVestingTextValues = () => get('Common/GetVestingTextValuesForDropdown');
export const getUserDetails = () => get('Common/GetUserDetails');
export const saveContactUs = (data) => post('Common/SaveContactUs',data);
export const saveDataUploadCenter = data => post('NotificationDataCenter/SaveOrUpdateNotificationData', data);
export const deleteNotificationFile = data => post('NotificationDataCenter/DeleteNotificationFile', data);
export const getCategoryForDropdown = () => get('Common/GetCategoryForDropdown');
